import { TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { FileBox } from './FileBox'
import { UploadBox } from './UploadBox'
import { UploadedFile } from './types'

interface Props {
  file: UploadedFile | null
  loadFiles: () => void
  canUpload: boolean
  torchAcknowledgement: boolean
  isFullFilm: boolean
}

export const SingleUpload = ({ file, loadFiles, canUpload, torchAcknowledgement, isFullFilm }: Props) => {
  const { t } = useTranslate('guild-create')

  if (file) return <FileBox file={file} loadFiles={loadFiles} disabled={!canUpload} />

  return (
    <>
      <TitleMD weight="bold" className="pt-4">
        {t('uploadAVideo169Preferred', 'Upload a Video (16:9 or 21:9 Preferred)')}
      </TitleMD>
      <UploadBox
        acknowledged={torchAcknowledgement}
        maxSize={isFullFilm ? 32_000_000_000 : 10_000_000_000}
        acceptedFileType="video"
        loadFiles={loadFiles}
      />
    </>
  )
}
